const paginationConstants = {
  CONDENSED_PAGE_SIZE: 5,
  DEFAULT_PAGE_SIZE: 10,
  NAV_ELEMENTS: 7
};

export default paginationConstants;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination/pagination.constants.js
 **/